import { Modal } from 'bootstrap';
require('owl.carousel');
require('jssocials');
var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
jQueryBridget( 'isotope', Isotope, $ );
require('isotope-masonry-horizontal');
import 'jquery.scrollto';
import anchorTool from '../components/anchorTool';
require('../components/accessible-owl-carousel');

export default {
	
	init() {
		
		// chiusura dei menu al click di 'Esc'
		$(document).on('keydown', function (event) {
			if (event.key === 'Escape') {
				$('nav.main-nav').fadeOut();
				$('.position-close').fadeOut();
				$('.hack-table').fadeOut();
				$('#hamburger').attr('aria-expanded', 'false');
				// $('#search-menu-mobile').attr('aria-expanded', 'false');
				closeSearch();
			}
		});
		
		// JavaScript to be fired on all pages

		// Suggestions - set clicked element in input value
		// $(document).on('click', '.suggestions li', function () {
		// 	$('.input-search').val($(this).text());
		// 	$('.suggestions').css('display', 'none');
		// });

		// Suggestions - Close dropdown if click outside
		$(document).mouseup(function(e) {
			if (!$('.suggestions li').is(e.target)) {
				$('.suggestions').css('display', 'none');
			}
		})

		/////////////////////////////////////
		// Icona Scroll Top
		$(document).scroll(function () {
			let y = $(this).scrollTop();
			if (y > 300) {
				$('.scroll-up').fadeIn();
			} else {
				$('.scroll-up').fadeOut();
			}
		});
		/////////////////////////////////////

		$('.search-form').submit(function (e) {
			e.preventDefault();
			autoCompleteSearch();
		});
		$('.input-search').keyup(function () {
			autoCompleteSearch();
		});

		let modalHTML = document.querySelector('#store-filter-list');
		if (modalHTML) { 
		
			const modalFilter = new Modal(document.querySelector('#store-filter-list'));
	
			// Modale boostrap che permette di esser cliccata
			$('#filter-button').on('keypress', function(e) {
				if (e.key === 'Enter' && !$(this).hasClass('disabled')) {
					modalFilter.show();
				}
			});  
		}

		var searchRunning = false;
		function autoCompleteSearch() {
			$('.suggestions').css('display', 'none');
			$('.suggestions').empty();
			var searchTerm = $('.input-search').val();
			if (searchTerm.length >= 2 && !searchRunning) {
				searchRunning = true;
				$('.submit-search').addClass('search-loading');
				setTimeout(() => {
					$.ajax({
						type : 'POST',
						url : window.idnah_ajaxurl,
						data : {
							action : 'autocompleteSearch',
							s : searchTerm,
						},
						success : function( r ) {
							if (r.data.length > 0) {
								$('.suggestions').empty();
								$('.results-info').removeClass('invisible');
								$('.number-of-results').text(r.data.length);

								let resultsInfo = $('.results-info').text().trim();
								resultsInfo = [1, 2, 3, 4, 5].includes(Number(resultsInfo[resultsInfo.length - 1])) ? resultsInfo.slice(0, -1):resultsInfo;
								resultsInfo = `${resultsInfo} ${r.data.length}`;

								$('.results-info').text(resultsInfo);
								r.data.forEach(element => {
									$('.suggestions').append('<li><a href="' + element.link + '" tabindex="0">' + element.label +'<div></div></a></li>');
								});
								$('.suggestions').css('display', 'block');
							}
						},
					});
					searchRunning = false;
					$('.submit-search').removeClass('search-loading');
				}, 400);
			} else {
				$('.results-info').addClass('invisible');
			}
		}

		var modalVideo = $('.modal-thumbs-video');
		modalVideo.on('hide.bs.modal', function () {
			let player = $(this).find('iframe').get(0);
			let command = {
				'event': 'command',
				'func': 'pauseVideo',
			};
			if (player !== undefined) {
				player.contentWindow.postMessage(JSON.stringify(command), '*');
			}
		})

        // SHARE COMPONENT
        $('.share').jsSocials({
            shares: ['twitter', 'facebook', 'linkedin'],
			// label: ['condividi twitter', 'condividi facebook', 'condividi linkedin'], 
			text: 'text to share', 
            showLabel: false,
            showCount: false,
        });
        $('.share-component-icon').click(function () {
            $('.share').toggleClass('show-social');
			let ariaSelected=$(this).attr('aria-selected');
			$(this).attr('aria-selected',(ariaSelected=='true')?'false':'true');
        });


		function socialLang(){
			var url = window.location.href;
			var urlObj = new URL(url); 
			var pathSegments = urlObj.pathname.split('/')[1]; 
			
			if(pathSegments=='en')
				return 'Share on ';
			
			return 'Condividi su ';
		}
		
		$('.jssocials-shares div').each(function(){
			$(this).attr('role', 'tab');
		})
		$('.jssocials-shares .jssocials-share a').each(function() {
			var socialName = $(this).closest('.jssocials-share').attr('class').match(/jssocials-share-([a-z]+)/);
			socialName = socialName ? socialName[1] : false;

			if (socialName) {
				$(this).attr('title', socialLang() + socialName);
			}
		});
		

		// Accordion menu
		$('nav.main-nav ul li div').on('click keypress', function (e) {
			if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){
				if (!$(this).hasClass('open')) {
					$('nav.main-nav ul li').each(function () {
						$(this).find('div').removeClass('open');
						$(this).find('ul').slideUp();
					});
				}
				$(this).siblings('ul').slideToggle();
				$(this).toggleClass('open');
			}
		});

		// Accordion menu
		$('nav.main-nav ul li').on('click keypress', function (e) {
			if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){

				//console.log($(this).find('a').attr('href'),e.target.className.indexOf('ico-open-menu'));

				let hrefLink = $(this).find('a').attr('href');
				let objLinkExpand = $(this).find('div');
				if(hrefLink == '#' && e.target.className.indexOf('ico-open-menu') == -1){

					if (!objLinkExpand.hasClass('open')) {
						$('nav.main-nav ul li').each(function () {
							$(this).find('div').removeClass('open');
							$(this).find('ul').slideUp();
						});
					}
					objLinkExpand.siblings('ul').slideToggle();
					objLinkExpand.toggleClass('open');

				}
			}
		});
		
		// nel menu i sottomenu con '+' aria-expanded vengono settati a 'false' quando un altro sotto menù viene aperto
		$('.ico-open-menu').on('click keypress',function (event) {
			if ((event.type === 'click') || (event.type === 'keypress' && event.key === 'Enter')){
				$('.ico-open-menu').not(this).each(function () {
					$(this).attr('aria-expanded', 'false');
				})
			}
		});


		// Close menu
		$('#close-menu, #close-menu-mobile').on('click keypress', function (e) {
			if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){
				$('nav.main-nav').fadeOut();
				$('.position-close').fadeOut();
				$('.hack-table').fadeOut();
				$('#hamburger').attr('aria-expanded', 'false');
				$('#search-menu-mobile').attr('aria-expanded', 'false');
			}
		});

		// Hamburger
		$('#hamburger').on('click keypress', function (e) {
			let exit=$('#exit');
			console.log('exit:'+exit.outerHTML);
			let index=0;
			console.log('index: '+index)
			index++;
			//TO DO
			if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){
				$('nav.main-nav').fadeIn().css('display', 'table');
				$('.hack-table').fadeIn();
				$('.position-close').fadeIn();

				//TO DO: tentativo di loop nel menù
				// let container = $('.main-ul-nav .container');
				// let allElementHamburgerMenu=$('.element-hamburger-menu');
				// // let firstFocusable = allElementHamburgerMenu.find('.ico-open-menu');
				// let firstFocusable = allElementHamburgerMenu.find('div.ico-open-menu').first();
				// // let lastFocusable = allElementHamburgerMenu.last();
				// container.on('keydown', function (e) {
				// 	if (e.key === 'Tab') {
				// 		// console.log(document.activeElement.outerHTML === $('#exit'))
				// 		if(document.activeElement.outerHTML===allElementHamburgerMenu[allElementHamburgerMenu.length-1].outerHTML){
				// 			firstFocusable.focus();
				// 		}
						
				// 		if(document.activeElement){
				// 			console.log('YEP');
				// 		} else {
				// 			console.log('SAD');
							
				// 		}
						
						
				// 	}
				// })


				// 


				

				// let elementFind = 'li:not(.only-mobile) a, li:not(.only-mobile) button, li:not(.only-mobile) [role="button"]:not(.only-mobile), [tabindex]:not([tabindex="-1"]):not(.only-mobile)';
        
				// // Limitiamo il focus all'interno del menu
				// trapFocus($('.main-ul-nav'), elementFind);
			}
		});
		

		function trapFocus(container, elementFind='') {
			let focusableElements = container.find(elementFind);
			let firstFocusable = focusableElements.first();
			let lastFocusable = focusableElements.last();
		
			container.on('keydown', function (e) {
				if (e.key === 'Tab') {
					focusableElements = container.find(elementFind);
					firstFocusable = focusableElements.first();
					lastFocusable = focusableElements.last();

					
					if (e.shiftKey) { 
						if (document.activeElement === firstFocusable[0]) {
							console.log(document.activeElement);
							e.preventDefault();
							lastFocusable.focus(); // Vai all'ultimo elemento
						}
					} else { 
						if (document.activeElement === lastFocusable[0]) {
							console.log(document.activeElement);
							e.preventDefault();
							firstFocusable.focus(); // Torna al primo elemento
						}
					}
				}
			});
		
			// All'apertura, sposta il focus sul primo elemento
			firstFocusable.focus();
		}

		
		const logo = $('.logo-desktop');
        const whiteLogo = logo.attr('data-img-white');
        const blackLogo = logo.attr('data-img-black');
		const fillAlways = $('header').hasClass('fill-always');
        let curLogo = logo.attr('src');
		
		// per il cambiamento dei loghi
		$(window).on('scroll resize',function () {
			const scroll = $(window).scrollTop();
			// ci troviamo all'inizio della pagina
			if (scroll >= 50) {
				$('header').addClass('fill');
				// situazione in cui lo sfondo dell'header cambia colore 
				if (curLogo.includes(whiteLogo) && !fillAlways) {
					curLogo = blackLogo;
				}
			} else {
				$('header').removeClass('fill');
				// situazione in cui lo sfondo dell'header cambia colore
				if (curLogo.includes(blackLogo) && !fillAlways) {
					curLogo = whiteLogo;
				}
			}
			if (!fillAlways) {
				logo.attr('src', curLogo);
			}
		});
		

		// Slider Intro Fullscreen
		$('.intro-slider-full .owl-carousel').owlCarousel({
			items: 1,
			loop: true,
			margin: 0,
			nav: true,
			dots: true,
			dotsEach: 1,
			animateIn: 'animate__fadeIn',
			animateOut: 'animate__fadeOut',
		})

        // Popup store
        // $('.popup-store .owl-carousel').owlCarousel({
        //     items: 1,
        //     loop: true,
        //     margin: 0,
        //     nav: false,
        //     dots: true,
        // });

		// tutti gli elementi con aria-expanded se cliccati cambiano il valore di aria-expanded 
		$('*[aria-expanded]').on('click', function () {
			const expanded = $(this).attr('aria-expanded') === 'true';
			$(this).attr('aria-expanded', expanded ? 'false' : 'true');
		});
		
		// Tendina Language
		// Desktop
		$('.header-block .language').on('click keypress', function (e) {
			if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){
				$('.header-block .language-list').slideToggle(300);
				$(this).toggleClass('open');
			}
		});
		// Mobile
		$('.only-mobile .language').on('click keypress', function (e) {
			if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){
				$('.language-list-mobile').slideToggle(300, function () {
					if ($(this).is(':visible'))
						$(this).css('display', 'block');
				});
				$(this).toggleClass('open');
			}
		});

		// Slider elementi multipli
		var sliderElementiMultipli = $('.slider-elementi-multipli .owl-carousel');
		var autoplayTimeout = 2500;
		sliderElementiMultipli.owlCarousel({
			center: true,
			items: 1.3,
			loop: true,
			margin: 0,
			dots: false,
            autoplay: true,
            autoplayTimeout: autoplayTimeout,
            autoplayHoverPause: true,
            smartSpeed: 1000,
			nav: true,
			responsive:{
				768:{
					items: 3,
					nav: true,
				},
				992:{
					items: 3,
					nav: true,
				},
				1400:{
					items: 4,
					nav: true,
				},
			},
			// onInitialized: function() {
			// 	setTimeout(() => {
			// 		owlSliderResize();
			// 	}, 300);
			// },
			// onResized: function() {
			// 	setTimeout(() => {
			// 		owlSliderResize();
			// 	}, 300);
			// },
		});

		var isPlaying = true;
		$('.carousel-play').on('click keydown', function (e) {
			if (e.key === 'Tab') return;
			e.preventDefault();
			if ((e.type === 'click') || (e.type === 'keydown' && e.key === 'Enter')){
				const carouselPlay = $('.carousel-play');
				const carouselImg = $('.carousel-play img');
				
				if(isPlaying){
					sliderElementiMultipli.trigger('stop.owl.autoplay');
					carouselImg.attr('src', carouselPlay.attr('stop'));
					carouselImg.attr('alt', 'stop');
				} else {
					sliderElementiMultipli.trigger('play.owl.autoplay', [autoplayTimeout]);
					carouselImg.attr('src', carouselPlay.attr('play'));
					carouselImg.attr('alt', 'play');
				}

				isPlaying = !isPlaying;
			}
			
		})



		// Slider Popup Marchi
        $('.popup-marchi .owl-carousel').owlCarousel({
            loop:true,
            margin:0,
            nav:true,
            dots: false,
            items: 1,
			autoHeight: true,
        });
		

        // Search
		$('#search-icon, #search-menu-mobile').on('click keypress', function (e) {
			if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')) {
				$('.search-fullscreen').fadeIn();
				$('.input-search').focus();
				let  elementFind='a, button, input, textarea, select, [tabindex]:not([tabindex="-1"]), #close-search';
				trapFocus($('.search-fullscreen'), elementFind);
			}
		});

		

		
		

		//chiusura del menù di ricerca
        $('#close-search').on('click keypress', function (e) {
			if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){
				closeSearch();
			}
		});


		function closeSearch(){
			$('.search-fullscreen').fadeOut();
			$('#search-icon, #search-menu-mobile').attr('aria-expanded', 'false');
			untrapFocus();
		}

		
		function untrapFocus() {
			$('.search-fullscreen').off('keydown');
		}


        let anchorComponent = null;

		// menu dentro il nostro mondo
        if($('.tool-ancore-standard').length > 0) {
			anchorComponent = new anchorTool(jQuery('.tool-ancore-standard'));

			let altezzaListAncora = $( '.tool-ancore-standard ul' ).height();
			if($('.wrap-components-ancorati .wrap-components-bg-blu').is(':last-child')) {
				let margineWrapBlu = parseInt($( '.wrap-components-bg-blu' ).css('margin-bottom'));
				altezzaListAncora += margineWrapBlu;
			}
			$( '.tool-ancore-standard + section' ).css('margin-top', - altezzaListAncora);
			$( '.tool-ancore-standard + .wrap-components-bg-blu' ).css('margin-top', - altezzaListAncora);
			$( '.tool-ancore-standard' ).css('margin-bottom', altezzaListAncora);
		}

		

		if($('.tool-ancore-avanzato').length > 0){
			anchorComponent = new anchorTool(jQuery('.tool-ancore-avanzato'));
		}

		let myHash = window.location.hash;

		if (myHash !== '' && $('.tool-ancore-standard').length > 0 || myHash !== '' && $('.tool-ancore-avanzato').length > 0) {
			setTimeout(function () {
				anchorComponent.scrollToBox(myHash.replace('#', ''));
			}, 1000);
		} else {
			let elmToScroll = $(myHash);
			setTimeout(function () {
				$(window).scrollTo(elmToScroll, {
					duration: 500,
					offset: {
						top: -($('header').height() + 50),
					},
				});
			}, 1000);
		}

		// no anchorTool click event
		if(!$('.tool-ancore-standard').length || !$('.tool-ancore-avanzato').length || !$('.skip-link').length) {
			$(document).on('click', 'a[href*="#"]:not([data-toggle="modal"])', function(event) {
				if ($(this).hasClass('skip-link')) {
					return;
				}
		
				if (event.target.href.split('#')[0] == window.location.href.split('#')[0]) {
					event.preventDefault();
					let elmToScroll = $(this.hash);
					if (elmToScroll.hasClass('modal')) {
						if ($('.search-fullscreen').is(':visible')) {
							$('.search-fullscreen').fadeOut();
						}
						if ($('.hack-table').is(':visible')) {
							$('.hack-table').fadeOut();
						}
						$(event.target.hash).modal('show');
					} else {
						if (elmToScroll.length == 0) {
							elmToScroll = $('#tgt-'+event.target.hash.replace('#',''));
						}
						if (elmToScroll.length > 0) {
							$(window).scrollTo(elmToScroll, {
								duration: 500,
								offset: {
									top: -($('header').height() + 50),
								},
							});
						}
					}
				}
			});
		}

		// Tool ancore avanzato
        $('.tool-ancore-avanzato-button-open').click(function () {
            $('.tool-ancore-avanzato ul').fadeIn();
        });
        $('#close-ancore').click(function () {
            $('.tool-ancore-avanzato ul').fadeOut();
        });

		// anchorComponent.scrollToBox(myHash.replace('#', ''));

        // STORE LOCATOR - START
        $('#open-store-list').click(function () { 
            $(this).addClass('active');
            $('#open-map').removeClass('active');
            $('.store-list').show();
            $('.store-map').hide();
        });
        $('#open-map').click(function () {
            $(this).addClass('active');
            $('#open-store-list').removeClass('active');
            $('.store-map').show();
            $('.store-list').hide();
        });
		// Store Locator Menu
		$('.store-locator .menu-list').change(function () {
			let selectedIndex = $(this).find(':selected').index();
			$(this).parent().parent().find('.search-type').hide();
			$(this).parent().parent().find('.search-type').eq(selectedIndex - 1).show();
			$(this).parent().parent().find('.disabled').removeClass('disabled');
			$(this).parent().parent().find('[aria-disabled]').attr('aria-disabled', 'false');
		});
		// STORE LOCATOR - END

        // BACK TO TOP
        $('.button-top, .scroll-up').on('click keypress', function (e) {
            if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){
				$('html, body').animate({scrollTop:0},500);
			}
        });

		// quando mi trovo nell'ultima voce del menù negli anni (.anno-btn) permette di non entrare dentro al contenuto, ma di passare alla sezione successiva, se non viene cliccato enter
		$('.anno-btn:last').on('keydown',function(e) {
			if(e.key === 'Tab' && !e.shiftKey){
				e.preventDefault();
				let currentSection = $(this).closest('section');
				let nextSection = currentSection.next('section');
				nextSection.focus();
			}
		});

		// nel caso la voce venga cliccata: entra dentro
		$('.wrap-anni-btn .anno-btn').click(function () { 
			let dataAnno = $(this).attr('data-year');
			let idData = '#' + dataAnno;
			let $thisButton = $(this);
		
			// Disattiva pulsanti
			$('.anno-btn.active').attr('aria-selected', 'false').removeClass('active');
		
			// Attiva il pulsante cliccato
			$thisButton.attr('aria-selected', 'true').addClass('active');
		
			// Nascondi il contenuto attivo, poi mostra il nuovo
			let $annoAttivo = $('.singolo-anno.active');
			$annoAttivo.fadeOut(function () {
				$annoAttivo.removeClass('active');
				let $nuovoAnno = $(idData);
				$nuovoAnno.fadeIn(function () {
					$nuovoAnno.addClass('active').attr('tabindex', '-1').focus();
		
					// Trova l'ultimo focusable nel nuovo contenuto
					let focusables = $nuovoAnno.find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
					let $firstFocusable = focusables.first();
					let $lastFocusable = focusables.last();
		
					// Shift+Tab sul primo: torna al pulsante anno
					if ($firstFocusable.length) {
						$firstFocusable.on('keydown', function (e) {
							if (e.key === 'Tab' && e.shiftKey) {
								e.preventDefault();
								$thisButton.focus();
							}
						});
					}
					// Se esiste un focusable dentro, aggiungi evento
					if ($lastFocusable.length) {
						$lastFocusable.on('keydown', function (e) {
							if (e.key === 'Tab' && !e.shiftKey) {
								e.preventDefault();
								$thisButton.focus(); // Torna al menu
							}
						});
					}
				});
			});
		});
		

        // // STORIA
        // $('#anni-40-btn').click(function () {
        //     $(this).addClass('active');
        //     $('#anni-50-btn').removeClass('active');
        //     $('#anni50').fadeOut();
        //     $('#anni40').fadeIn();
        // });
        // $('#anni-50-btn').click(function () {
        //     $(this).addClass('active');
        //     $('#anni-40-btn').removeClass('active');
        //     $('#anni40').fadeOut();
        //     $('#anni50').fadeIn();
        // });
		$('.scroll-down').on('click keypress', function (e) {
			if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){

				let elmToScroll = $(this).parents('section').next('section');
	
				$(window).scrollTo(elmToScroll, {
					duration: 500,
					offset: {
						//top: -(jQuery('header').height() + containerHeight + elmPaddingTop),
						top: -($('header').height() + 50),
					},
				});
	
			}
		});
		
		$('#anchor_at_main').click(function(){
			const main = document.querySelector('main'); // Seleziona il primo elemento <main>
			if (main) {
				main.scrollIntoView({ behavior: 'smooth' }); // Scorrimento fluido
			} 
		});




		$(window).load(function(){

			/**
			 * Marchi filtri
			 * */
			var $grid = $('.marchi-wrapper-filter').isotope({
				itemSelector: '.item-filter-marchi',
				percentPosition: true,
				masonry: {
					// set to the element
					itemSelector: '.item-filter-marchi',
					columnWidth: '.grid-sizer',
					initLayout: false,
				},
				getSortData: {
					category: '[data-category]',
				},
			});

			$('.loader-marchi-grid').hide();
			$('.item-filter-marchi').css('visibility','visible');

			// $grid.on( 'arrangeComplete', function(){
			// 	$('.item-filter-marchi').css('visibility','visible');
			// });

			$('label .wpcf7-list-item-label').on('keypress',function(e){
				e.preventDefault();
				$(this).click();
				
			})


			$('.filtro-singolo').on('click keypress', function (e) {
				if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){
					if(!$(this).hasClass('filtro-all') || ($(this).hasClass('filtro-all') && !$(this).hasClass('active'))){

						$(this).toggleClass('active');
						$(this).attr('aria-selected', $(this).hasClass('active') ? 'true' : 'false');
					
						var filterValue = '';
					
						if ($(this).hasClass('filtro-all')) {
							$('.filtro-singolo:not(.filtro-all)')
								.removeClass('active')
								.attr('aria-selected', 'false');
						} else {
							$('.filtro-all')
								.removeClass('active')
								.attr('aria-selected', 'false');
					
							$('.filtro-singolo.active').each(function () {
								filterValue += '.' + $(this).attr('data-filter') + ', ';
							});
					
							if ($('.filtro-singolo.active:not(.filtro-all)').length === 0) {
								$('.filtro-all')
									.addClass('active')
									.attr('aria-selected', 'true');
							}
						}
						filterValue = filterValue.slice(0, -2);
						$grid.isotope({ filter: filterValue });
					}
				}	
			});
			



			// if ($('#iubenda-cs-banner').length > 0) {
			// 	console.log('elemento esiste!');
			// } else {
			// 	console.log('elemento non esiste.');
			// }
			
			



		});

		//
		// var currentCollapseJobAccordion = null;
		//
		// $('.accordion .collapse').on('show.bs.collapse', function() {
		// 	currentCollapseJobAccordion = $(this);
		// });
		//
		// $('.accordion .collapse').on('hidden.bs.collapse', function () {
		// 	if($('body').hasClass('mobile')) {
		// 		var component = currentCollapseJobAccordion.parent().find('.header-accordion');
		// 		$('html,body').animate({
		// 			scrollTop: component.offset().top -50
		// 		}, 500);
		// 	}
		// });

		$('.accordion .collapse').on('shown.bs.collapse', function() {
			var $panel = $(this).closest('.accordion-card');
			//console.log($('header').height());
			$('html,body').animate({
				scrollTop: $panel.offset().top - $('header').height(),
			}, 500);
		});

		// function owlSliderResize() {
		// 	let all_items_h = [];
		// 	let itemsSlider = $('.slider-elementi-multipli .elemento img');
		// 	$(itemsSlider).each(function() {
		// 		all_items_h.push(floatToInt($(this).height()));
		// 	});
		// 	let best_min_h = Math.min(...all_items_h);
		// 	$('.slider-elementi-multipli .elemento').each(function() {
		// 		$(this).height(best_min_h);
		// 	});
		// }

		// function floatToInt(value)
		// {
		// 	if (value < 0) {
		// 		return Math.ceil(value);
		// 	}
		// 	return Math.floor(value);
		// }

		//DATA LAYER
		window.dataLayer = window.dataLayer || [];

		//TRACKING POPUP HP BTN
		$('#popup-manageable .modal-body .text-wrapper a.button').on('click', function() {

			let btnLink = $(this).attr('href');
			//console.log(btnLink);

			window.dataLayer.push({
				'event': 'button_click',
				'eventCategory': 'button_click_popup',
				'eventAction': 'registrati_subito' ,
				'eventLabel': btnLink,
			});

		});

		
		// gestisce lo skip-link
		// $('.skip-link').on('keydown', function (e) {
		// 	if (e.key === 'Enter') {
		// 		e.preventDefault(); 
		// 		const mainContent = $('#main-content');
		
		// 		if (mainContent.length) {
		// 			mainContent.attr('tabindex', '-1'); 
		// 			mainContent.focus(); 
					
		// 			// blur -> evento che si attiva quando l'elemento non ha più il focus
		// 			mainContent.on('blur', function () {
		// 				$(this).removeAttr('tabindex');
		// 			});
		// 		}
		// 	}
		// });

		
		
		



	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		// $('.slider-elementi-multipli .owl-carousel .owl-item a, .slider-elementi-multipli .owl-nav button').on('focus', function () {
		// 	$(this).trigger('stop.owl.autoplay');
		// });

		// $('.slider-elementi-multipli .owl-carousel').on('focusout', function () {
		// 	$(this).trigger('play.owl.autoplay');
		// });

		//aria-label on owl-dots
		$('.owl-carousel').each(function() {
			$(this).find('.owl-dot').each(function(index) {
				$(this).attr('aria-label', index + 1);
			});
		});
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js